import React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'gatsby'

import { Layout, PostCard, Pagination } from '../components/common'
import { MetaData } from '../components/common/meta'

/**
* Tag page (/tag/:slug)
*
* Loads all posts for the requested tag incl. pagination.
*
*/
const Tag = ({ data, location, pageContext }) => {
    const tag = data.ghostTag;

    let posts = data.allGhostPost.edges;
    let featuredCount = 0;

    posts.forEach((post, index) => {
        if(post.node.featured) {
            featuredCount++;
            if(index == 1) {
                posts[0].node.featured = true;
            }

            if(index == posts.length - 2) {
                posts[index].node.featured = true;
            }
        }
    })

    const count = posts.length - featuredCount;
    const odd = count % 2;

    return (
        <>
            <MetaData
                data={data}
                location={location}
                type="series"
            />
            <Layout activePage={tag.name}>
                <div className="container">
                    <header className="tag-header">
                        <h1>{tag.name}</h1>
                        {tag.description ? <p>{tag.description}</p> : null }
                    </header>
                    <section className={odd ? 'post-feed odd' : 'post-feed'}>
                        {posts.map(({ node }) => (
                            // The tag below includes the markup for each post - components/common/PostCard.js
                            <PostCard key={node.id} post={node} />
                        ))}
                    </section>
                    <Pagination pageContext={pageContext} />
                </div>
            </Layout>
        </>
    )
}

Tag.propTypes = {
    data: PropTypes.shape({
        ghostTag: PropTypes.shape({
            name: PropTypes.string.isRequired,
            description: PropTypes.string,
        }),
        allGhostPost: PropTypes.object.isRequired,
        breakpoints: PropTypes.array,
        sizes: PropTypes.string
    }).isRequired,
    location: PropTypes.shape({
        pathname: PropTypes.string.isRequired,
    }).isRequired,
    pageContext: PropTypes.object,
}

export default Tag

export const pageQuery = graphql`
    query GhostTagQuery(
      $slug: String!,
      $limit: Int!,
      $skip: Int!,
      $breakpoints: [Int] = [1200, 980, 680, 420, 320],
    ) {
        ghostTag(slug: { eq: $slug }) {
            ...GhostTagFields
        }
        allGhostPost(
            sort: { order: DESC, fields: [published_at] },
            filter: {tags: {elemMatch: {slug: {eq: $slug}}}},
            limit: $limit,
            skip: $skip
        ) {
            edges {
                node {
                ...GhostPostFields
                published_at_de: published_at(formatString: "DD.MM.YYYY")
                fields {
                  sizes
                }
                localImage {
                    childImageSharp {
                      fluid(
                        srcSetBreakpoints: $breakpoints,
                        fit: COVER,
                        toFormat: JPG,
                        quality: 90) {
                        ...GatsbyImageSharpFluid_withWebp
                      }
                    }
                }
                }
            }
        }
    }
`
